var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleDesktopPerson = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M6 8c2.986 0 4.413.76 5.76 2 .05.943.24 2 .24 2H0v-.17c.003-.29.013-.901.048-1.387C1.607 8.947 2.019 8 6 8m0-8a3.25 3.25 0 1 1 0 6.5A3.25 3.25 0 0 1 6 0"
})));
export default SvgGoogleDesktopPerson;